import React from 'react';
import {
  StyledDayBox,
  StyledDayNumberTypography,
  StyledDayTypography
} from '../hooks/useGetColumns.styles';
import dayjs from 'dayjs';

const DayHeader = ({ date, isToday }: { date: string; isToday: boolean }) => {
  return (
    <StyledDayBox>
      <StyledDayTypography variant="body2">
        {dayjs(date).format('ddd')}
      </StyledDayTypography>
      <StyledDayNumberTypography variant="body1" isToday={isToday}>
        {dayjs(date).format('D')}
      </StyledDayNumberTypography>
    </StyledDayBox>
  );
};

export default DayHeader;
